/**
 * Implement accessing to a radio stations list, favorites list.
 * Inner API realization as an abstract level for specific providers.
 *
 * @module data.provider
 *
 * @author Yaroslav Surilov <y.surilov@infomir.com>
 */

'use strict';

var config          = require('../config'),
    badRequestError = {message: 'Bad request error!'};


module.exports = {
    /**
     * Return a list of radio channels.
     *
     * @param {Object} queryStringSet - set of name-value GET parameters
     * @param {Function} callback - callback function
     */
    getRadioChannels: function ( queryStringSet, callback ) {
        var queryString = '?';

        Object.keys(queryStringSet).forEach(function ( name, index, array ) {
            queryString += name + '=' + queryStringSet[name] + ['&', ''][+(index === array.length - 1)];
        });

        core.backend.request(config.resource + queryString, {
            onload: function ( error, response ) {
                if ( error ) {
                    callback(badRequestError);
                } else {
                    callback(null, response);
                }
            },
            onerror: function () {
                callback(badRequestError);
            }
        });
    },
    /**
     * Add or delete channel from favorites list.
     *
     * @param {number} channelId - ID of the radio channel
     * @param {string|boolean} favoriteState - favorites flag in some form
     * @param {Function} callback - callback function
     */
    setRadioChannelFavoriteState: function ( channelId, favoriteState, callback ) {
        core.backend.request(config.resource + channelId, {
            method: 'PUT',
            body: favoriteState,
            onload: function ( error, response ) {
                if ( error ) {
                    callback(badRequestError);
                } else {
                    callback(null, response);
                }
            },
            onerror: function () {
                callback(badRequestError);
            }
        });
    }
};
